import { useContext } from 'react'
import { AuthContext } from '../../contexts/auth.context'

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider')
  }

  // Provide a clean interface with proper destructuring
  const {
    // Core authentication state
    user,
    loading,
    isAuthenticated,
    hasClientToken,

    // Client token data
    clientToken,
    anonymousId,
    conversationHistory,

    // UUID data
    currentConversationId,
    conversationStartTime,

    // Authentication methods
    signInWithEmail,
    signUpWithEmail,
    signOut,
    signInWithProvider,

    // Utility functions
    updateConversationHistory,
    getCurrentToken,

    // UUID functions
    getOrCreateConversationId,
    clearConversationId,
    generateMessageId,

    // Backward compatibility
    isAnonymous,
  } = context

  return {
    // Authentication state
    user,
    loading,
    isAuthenticated,
    hasClientToken,

    // Client token data
    clientToken,
    anonymousId,
    conversationHistory,

    // UUID data
    currentConversationId,
    conversationStartTime,

    // Authentication methods
    signInWithEmail,
    signUpWithEmail,
    signOut,
    signInWithProvider,

    // Utility functions
    updateConversationHistory,
    getCurrentToken,

    // UUID functions
    getOrCreateConversationId,
    clearConversationId,
    generateMessageId,

    // Backward compatibility (deprecated - use isAuthenticated)
    isAnonymous,

    // Helper computed properties
    userLevel: user?.app_metadata?.user_level || 'guest',
    userEmail: user?.email || null,
    userName: user?.user_metadata?.first_name || user?.email?.split('@')[0] || null,
  }
}
